export type OrderPaymentInstallmentSnapshot = {
  installments: number | null
  passedFeeCents: number | null
  chargedAmountCents: number | null
}

/** Latest credit (or multi-installment) payment used to show parcelas and the charged total. */
export function installmentSnapshotFromPayments(
  payments:
    | Array<{
        providerPaymentType?: string | null
        installments?: number | null
        passedFeeCents?: number | null
        amountCents?: number | null
      }>
    | null
    | undefined
): OrderPaymentInstallmentSnapshot {
  const empty: OrderPaymentInstallmentSnapshot = {
    installments: null,
    passedFeeCents: null,
    chargedAmountCents: null,
  }
  if (!payments?.length) return empty
  const preferred =
    [...payments].reverse().find((p) => (p.providerPaymentType ?? '').toLowerCase() === 'credit') ??
    [...payments].reverse().find((p) => (p.installments ?? 0) > 1) ??
    null
  if (!preferred) return empty
  return {
    installments: preferred.installments ?? null,
    passedFeeCents: preferred.passedFeeCents ?? null,
    chargedAmountCents: typeof preferred.amountCents === 'number' ? preferred.amountCents : null,
  }
}

/** Cart total unless a credit charge includes installments or a passed fee. */
export function displayTotalWithInstallmentCharge(
  cartTotal: number,
  snapshot: Pick<OrderPaymentInstallmentSnapshot, 'chargedAmountCents' | 'passedFeeCents' | 'installments'>
): number {
  const chargedAmountCents = snapshot.chargedAmountCents
  if (
    chargedAmountCents != null &&
    ((snapshot.passedFeeCents ?? 0) > 0 || (snapshot.installments ?? 1) > 1)
  ) {
    return chargedAmountCents / 100
  }
  return cartTotal
}
